import { useContext } from 'react';
import { ProjectFilterContext } from './projectContext';
import type { ProjectFilterContextValue } from './projectTypes';

export const useProjectFilter = (): ProjectFilterContextValue => {
  const ctx = useContext(ProjectFilterContext);
  if (!ctx) {
    throw new Error('useProjectFilter must be used within ProjectFilterProvider');
  }
  return ctx;
};
